import React from 'react';
import styled from '@emotion/styled'
import { Link } from 'react-router-dom';

const FooterWrapperName = styled.footer`
    display: block;
    width: 100%;
    height: 100px;
    nav {
        position: fixed;
        left: 0;
        bottom: 25px;
        width: 100%;
        display: flex;
        justify-content: center;
        box-sizing: border-box;
        ul {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            border-radius: 40px;
            gap: 10px;
            padding: 9px;
            border: 1px solid rgba(255, 255, 255, .75);
            background: rgba(255, 255, 255, 0.25);
            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.10);
            backdrop-filter: blur(20px);
            li {
                a {
                    display: flex;
                    max-width: 35px;
                    max-height: 35px;
                    min-width: 35px;
                    min-height: 35px;
                    align-items: center;
                    justify-content: center;
                    aspect-ratio: 1/1;
                    border-radius: 99999px;
                    background-color: #41BBFF;
                    @media screen and (min-width: 768px) { 
                        max-width: 55px;
                        max-height: 55px;
                        min-width: 55px;
                        min-height: 55px;
                    }
                    &.minesweeper{
                        background-color: #FF419C;
                    }
                    &.discord {
                        background-color: #4154FF;
                    }
                    &:hover {
                        img{
                            display: none;
                        }
                        span {
                            color: var(--color-white-900);
                            display: block;
                        }
                    }
                    span {
                        display: none;
                        font-size: 12px;
                        font-weight: 700;
                    }
                    img {
                        display: block;
                        width: 100%;
                    }
                    
                }
            }
        }
    }
`

const FooterCommon = ()=>{
    return(
        <FooterWrapperName>
            <nav>
                <ul>
                    <li>
                        <Link to="/" className="home">
                            <img src="/image/icon/icon_home_white.png" alt="" />
                            <span>
                                홈
                            </span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/game/minesweeper" className="minesweeper">
                            <img src="/image/icon/icon_minesweeper_white.png" alt="" />
                            <span>
                                너의 선택
                            </span>
                        </Link>
                    </li>
                    <li>
                        <a href="https://discord.gg/RrmUfEDavJ" target="_blank" rel="noreferrer" className="discord">
                            <img src="/image/icon/icon_discord_white.png" alt="" />
                            <span>
                                디스코드
                            </span>
                        </a>
                    </li>
                </ul>
            </nav>
        </FooterWrapperName>
    )

}

export default FooterCommon;